import { render } from "./BCard.vue?vue&type=template&id=928a7b78&ts=true"
import script from "./BCard.vue?vue&type=script&lang=ts"
export * from "./BCard.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__